import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { LifecycleResDto } from '../_dtos/lifecycleResDto';
import { LifecycleReqDto } from '../_dtos/lifecycleReqDto';

@Injectable({
  providedIn: 'root',
})
export class LifecycleService {
  private extendLifecycle =
    environment.backendBaseUrl + '/lifeCycle/extendLifeCycle';

  constructor(private http: HttpClient) {}

  renewLifecycle(lifecycleData: LifecycleReqDto): Observable<LifecycleResDto> {
    return this.http.patch<LifecycleResDto>(
      this.extendLifecycle,
      lifecycleData,
    );
  }
}
